import { AfterViewInit, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { DateService } from '../common/date.service';
import { GroupOfferListComponent } from '../group-offer/group-offer-list/group-offer-list.component';

@Component({
	selector: 'app-terms',
	templateUrl: './terms.component.html',
	styleUrls: ['./terms.component.css', '../../app/group-offer/group-offer-list/group-offer-list.component.css'],
	encapsulation: ViewEncapsulation.None,
})
export class TermsComponent extends GroupOfferListComponent implements AfterViewInit {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;
	protected dateService = new DateService();

	protected itemsBeforeDataLoad = 4;

	protected apiUrl = 'offer/term';

	displayedColumns: string[] = [
		'checkbox',
		'id',
		'offerName',
		'product',
		'locations',
		'nightsNumber',
		'dateRangeLower',
		'dateRangeUpper',
		'transportKind',
		'stopSale',
		'www',
		'merlinx',
		'promotion',
		'archived',
		'status',
	];

	parameters = {
		yesno: [
			{ id: 1, name: 'Tak', value: true },
			{ id: 2, name: 'Nie', value: false },
		],
		products: [],
		locations: [],
		groupOffers: [],
		massAction: [
			{ name: 'StopSale', value: 'stopSale' },
			{ name: 'WWW', value: 'www' },
			{ name: 'MerlinX', value: 'merlinx' },
			{ name: 'Promowany', value: 'promotion' },
			{ name: 'Archiwum', value: 'archived' },
		],
	};

	protected loadBefore(): void {
		this.bag.get('/product/?limit=9999', (result, error) => {
			this.parameters.products = result.results;
			this.loadData();
		});
		this.bag.get('/location/?limit=9999', (result, error) => {
			this.parameters.locations = result.results;
			this.loadData();
		});
		this.bag.get('/offer/group_offer/?limit=9999', (result, error) => {
			this.parameters.groupOffers = result.results;
			this.loadData();
		});
	}

	ngAfterViewInit() {
		this.matData.sort = this.sort;
		this.matData.sortingDataAccessor = (item, property) => {
			switch (property) {
				case 'product':
					return item.product.name;
				case 'dateRangeLower':
					return new Date(item.dateRange?.lower);
				case 'dateRangeUpper':
					return new Date(item.dateRange?.upper);
				default:
					return item[property];
			}
		};
		this.matData.filterPredicate = function (data, filter: string): boolean {
			return (
				data.product.name.toLowerCase().includes(filter) ||
				data.offerName.toLowerCase().includes(filter) ||
				data.locations.toString().includes(filter)
			);
		};
		this.matData.paginator = this.paginator;
	}

	protected convertData(result) {
		this.matData.data = result.results.map((obj) => {
			obj.locations = obj.locations.map((v) => {
				return this.parameters.locations.find((e) => e.id === v.id)?.name;
			});
			obj.checked = false;
			obj.dateRange.upper = this.dateService.daysAdd(-1, obj.dateRange.upper);
			return obj;
		});

		this.showTable = this.matData.data.length == 0 ? false : true;
	}

	protected sendData(arrayToSend) {
		this.loader.show();
		this.bag.put('/' + this.apiUrl + '/bulk_update/', arrayToSend, (result, error) => {
			if (error) {
				return;
			}
			this.infobox.success('Zapisano');
			this.loader.hide();
		});
	}

	protected getNightsNumber(upper, lower) {
		return this.dateService.daysBetween(lower, upper);
	}

	filtersSelected(data) {
		this.filters = data;
		if (!this.filters) {
			this.filters.date_range = [this.date.daysAdd(), this.date.daysAdd(+14)];
		}

		this.loadData();
	}
}
